exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck.ck-reset {\n\twidth: inherit;\n}\n\n.ck-balloon-panel {\n\tz-index: 2000 !important;\n}\n\n#bulletin-dialog figure.image img {\n max-width: 100%;\n}", ""]);

// exports
